import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isIframe: boolean }>`
	${({ $isIframe }) =>
		$isIframe &&
		css`
			margin-top: 56px;
		`}
`;

export const Content = styled.div`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	position: relative;
	width: 100%;
	z-index: 2;
	display: flex;
	flex-direction: column;
`;

export const Row = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 24px;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const ContentLeft = styled.div`
	max-width: 603px;
	width: 100%;
`;

export const Title = styled.h2`
	font-size: 48px;
	font-weight: 700;
	line-height: 1.2;
	color: ${({ theme }) => theme.colors.text.title};
	margin: 0 0 12px;

	@media (max-width: 992px) {
		font-size: 32px;
		line-height: 38px;
	}
`;

export const Text = styled.p`
	font-size: 18px;
	line-height: 0.8;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
	margin: 0;
	letter-spacing: -0.02em;
  line-height: 1.3;

	@media (max-width: 992px) {
		font-size: 16px;
		line-height: 20px;
	}
`;

export const ButtonRow = styled.div`
	margin-top: 20px;
	display: flex;
	gap: 16px;
	flex-wrap: wrap;
`;

export const MainImage = styled.img`
	width: 400px;
	height: auto;
	object-fit: contain;
	flex-shrink: 0;
`;

export const Panels = styled.div`
	display: flex;
	gap: 20px;
	justify-content: space-between;

  @media (max-width: 768px) {
		flex-direction: column;
	}
`;

export const Panel = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const PanelImage = styled.img`
	width: 100px;
	height: auto;
	object-fit: contain;
	flex-shrink: 0;
`;

export const PanelContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	max-width: 480px;
`;

export const PanelTitle = styled.h4`
	margin: 0;
	color: ${({ theme }) => theme.colors.text.title};
	font-size: 20px;
`;

export const PanelText = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 16px;
	line-height: 1.4;
`;

